import { useEffect, useState } from "react";

/**
 * The current time, refreshed on an interval.
 *
 * For anything that ages visibly while nobody touches it — "issued 3m ago",
 * a presence dot about to go stale — without every consumer running its own
 * `setInterval`.
 */
export function useNow(intervalMs = 5000): number {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const timer = setInterval(() => setNow(Date.now()), intervalMs);
    return () => clearInterval(timer);
  }, [intervalMs]);

  return now;
}
